import { useTranslation } from 'react-i18next';

const standardImg = 'http://geel.fp.08wx.cn/images/f3e48841839ab4db408ae0628285e57a.jpg';

const COPY = {
  'zh-CN': {
    title: '标准单体架构',
    highlight: '快速上线，低成本启动',
    desc: '面向中小型交易所或初创项目，采用成熟的单体架构设计，部署简单、运维成本低，可在 4-8 周内完成上线。系统具备完整的现货交易、资产管理、用户中心、行情数据与运营后台功能。',
    specTitle: '技术规格参考',
    cardTitle: '标准单体架构',
    cardSub: '快速部署 · 低门槛启动',
    tags: ['现货交易', '用户中心', '资产管理', '行情深度', 'KYC 模块', '运营后台'],
    coreFeatures: [
      { icon: 'ri-swap-line', title: '高性能撮合引擎', desc: '内存级订单撮合，延迟 &lt;1ms，支持限价/市价/止盈止损等多种订单类型' },
      { icon: 'ri-shield-user-line', title: 'KYC / AML 合规', desc: '内置身份验证、人脸识别、反洗钱风控，对接主流合规 API 服务商' },
      { icon: 'ri-device-line', title: 'PC / H5 / APP 多端', desc: '统一后台，多端同步，交易体验一致，支持 PWA 离线缓存' },
      { icon: 'ri-exchange-2-line', title: '撮合 + 报价一体', desc: '现货/合约/期权/币币兑换 多品类交易对，支持做市商 API' },
      { icon: 'ri-lock-password-line', title: '资产安全体系', desc: '冷热钱包分离、多签授权、风控熔断、异常检测一体化' },
      { icon: 'ri-bar-chart-grouped-line', title: '运营数据后台', desc: '用户分析、资产统计、收益报表、风控审计日志全覆盖' },
    ],
    specs: [
      { label: '撮合 TPS', val: '100,000+' },
      { label: '订单延迟', val: '< 1ms' },
      { label: '交易对数量', val: '无上限' },
      { label: '部署周期', val: '4-8 周' },
      { label: '服务器要求', val: '单台 32C / 128G' },
      { label: '源码交付', val: '✓ 全量' },
    ],
  },
  en: {
    title: 'Standard Monolith Architecture',
    highlight: 'Fast Launch, Lower Cost',
    desc: 'Designed for small-to-mid exchanges and startup teams. This mature monolith architecture is easy to deploy and maintain, with launch cycles as fast as 4-8 weeks. It includes spot trading, asset management, user center, market data, and operations backend.',
    specTitle: 'Technical Specs',
    cardTitle: 'Standard Monolith Architecture',
    cardSub: 'Fast Deployment · Low Entry Barrier',
    tags: ['Spot Trading', 'User Center', 'Asset Management', 'Market Depth', 'KYC Module', 'Operations Console'],
    coreFeatures: [
      { icon: 'ri-swap-line', title: 'High-Performance Matching Engine', desc: 'In-memory order matching with &lt;1ms latency and support for limit/market/TP-SL order types.' },
      { icon: 'ri-shield-user-line', title: 'KYC / AML Compliance', desc: 'Built-in identity verification, facial checks, AML controls, and integration with mainstream compliance APIs.' },
      { icon: 'ri-device-line', title: 'PC / H5 / APP Multi-Terminal', desc: 'Unified backend across terminals with consistent UX and PWA offline cache support.' },
      { icon: 'ri-exchange-2-line', title: 'Matching + Quotation Integrated', desc: 'Spot/perpetual/options/convert pairs in one system, with market-maker API support.' },
      { icon: 'ri-lock-password-line', title: 'Asset Security Framework', desc: 'Hot/cold wallet separation, multisig authorization, risk circuit breakers, and anomaly detection.' },
      { icon: 'ri-bar-chart-grouped-line', title: 'Operations Data Console', desc: 'Covers user analytics, asset stats, revenue reporting, and risk/audit logs.' },
    ],
    specs: [
      { label: 'Matching TPS', val: '100,000+' },
      { label: 'Order Latency', val: '< 1ms' },
      { label: 'Trading Pairs', val: 'Unlimited' },
      { label: 'Deployment Window', val: '4-8 weeks' },
      { label: 'Server Requirement', val: 'Single node 32C / 128G' },
      { label: 'Source Delivery', val: '✓ Full' },
    ],
  },
  'zh-TW': {
    title: '標準單體架構',
    highlight: '快速上線，低成本啟動',
    desc: '面向中小型交易所或初創項目，採用成熟的單體架構設計，部署簡單、運維成本低，可在 4-8 週內完成上線。系統具備完整的現貨交易、資產管理、用戶中心、行情數據與運營後台功能。',
    specTitle: '技術規格參考',
    cardTitle: '標準單體架構',
    cardSub: '快速部署 · 低門檻啟動',
    tags: ['現貨交易', '用戶中心', '資產管理', '行情深度', 'KYC 模塊', '運營後台'],
    coreFeatures: [
      { icon: 'ri-swap-line', title: '高性能撮合引擎', desc: '內存級訂單撮合，延遲 &lt;1ms，支持限價/市價/止盈止損等多種訂單類型' },
      { icon: 'ri-shield-user-line', title: 'KYC / AML 合規', desc: '內置身份驗證、人臉識別、反洗錢風控，對接主流合規 API 服務商' },
      { icon: 'ri-device-line', title: 'PC / H5 / APP 多端', desc: '統一後台，多端同步，交易體驗一致，支持 PWA 離線緩存' },
      { icon: 'ri-exchange-2-line', title: '撮合 + 報價一體', desc: '現貨/合約/期權/幣幣兌換 多品類交易對，支持做市商 API' },
      { icon: 'ri-lock-password-line', title: '資產安全體系', desc: '冷熱錢包分離、多簽授權、風控熔斷、異常檢測一體化' },
      { icon: 'ri-bar-chart-grouped-line', title: '運營數據後台', desc: '用戶分析、資產統計、收益報表、風控審計日誌全覆蓋' },
    ],
    specs: [
      { label: '撮合 TPS', val: '100,000+' },
      { label: '訂單延遲', val: '< 1ms' },
      { label: '交易對數量', val: '無上限' },
      { label: '部署週期', val: '4-8 週' },
      { label: '服務器要求', val: '單台 32C / 128G' },
      { label: '源碼交付', val: '✓ 全量' },
    ],
  },
} as const;

function currentLocale(lng: string) {
  if (lng.startsWith('zh-TW')) return 'zh-TW';
  if (lng.startsWith('en')) return 'en';
  return 'zh-CN';
}

export default function CexStandardSection() {
  const { i18n } = useTranslation();
  const lng = i18n.resolvedLanguage || i18n.language || 'zh-CN';
  const copy = COPY[currentLocale(lng)];

  return (
    <section id="standard" className="bg-white py-24">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-14 xl:gap-20">
          <div className="flex-1 min-w-0">
            <div className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full">
              <i className="ri-server-line text-primary text-xs" />
              <span className="text-primary text-xs font-medium uppercase tracking-widest">Standard Edition</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-4 leading-tight">
              {copy.title}
              <br />
              <span className="text-primary">{copy.highlight}</span>
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-8">
              {copy.desc}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
              {copy.coreFeatures.map((f, i) => (
                <div key={i} className="bg-light-alt border border-primary/10 rounded-xl p-4 group hover:border-primary/25 transition-all duration-200">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary/10 flex-shrink-0 mt-0.5">
                      <i className={`${f.icon} text-sm text-primary`} />
                    </div>
                    <div>
                      <h4 className="text-gray-800 text-sm font-medium mb-1">{f.title}</h4>
                      <p className="text-gray-500 text-xs leading-relaxed" dangerouslySetInnerHTML={{ __html: f.desc }} />
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-light-alt border border-primary/10 rounded-xl overflow-hidden">
              <div className="px-5 py-3 border-b border-primary/10 bg-primary/5">
                <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">{copy.specTitle}</span>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3">
                {copy.specs.map((s, i) => (
                  <div key={i} className={`px-5 py-4 ${i < copy.specs.length - 3 ? 'border-b' : ''} border-primary/10 ${i % 3 !== 2 ? 'border-r' : ''}`}>
                    <div className="text-gray-400 text-xs mb-1">{s.label}</div>
                    <div className="text-primary font-semibold text-sm">{s.val}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:w-[420px] xl:w-[500px] flex-shrink-0">
            <div className="relative rounded-2xl overflow-hidden border border-primary/15 sticky top-24">
              <div className="w-full h-[340px]">
                <img src={standardImg} alt="Standard CEX Architecture" className="w-full h-full object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-white/60 via-transparent to-transparent" />
              </div>
              <div className="absolute top-4 left-4 bg-white/95 border border-primary/20 rounded-xl px-4 py-3 backdrop-blur-sm">
                <div className="flex items-center gap-2 mb-1">
                  <i className="ri-server-line text-primary text-sm" />
                  <span className="text-gray-800 text-xs font-medium">{copy.cardTitle}</span>
                </div>
                <div className="text-gray-400 text-xs">{copy.cardSub}</div>
              </div>
              <div className="absolute bottom-6 left-4 right-4 flex flex-wrap gap-2">
                {copy.tags.map((tag, i) => (
                  <span key={i} className="px-2.5 py-1 bg-white/95 border border-primary/20 text-primary text-xs rounded-lg backdrop-blur-sm">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
